import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { OnlyExcursionPackage } from '@appTypes/api.types';
import { TranslatePipe } from '@ngx-translate/core';
import { PriceFormatPipe } from '@shared/pipes/price-format.pipe';

/** TravelDesk Plan 2b: an excursion in the cart - name, day, party, pickup, price. */
@Component({
  selector: 'app-cart-excursion-item-view',
  templateUrl: './cart-excursion-item-view.component.html',
  imports: [MatIcon, DatePipe, PriceFormatPipe, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CartExcursionItemViewComponent {
  readonly data = input<OnlyExcursionPackage>();
  /** docs#451 P8: the chosen pickup hotel's name kept on the cart item (absent on items added before 29.10.2026). */
  readonly pickupHotelName = input<string | null | undefined>(null);

  /**
   * docs#451 P8 (excursions-ui "Pick-up"): what the agent chose, never the price's Pick-up Point text - the hotel's name, else the typed address;
   * an offer without transfer says "no pickup - direct entry". A hotel whose name the item does not carry reads "pickup from your hotel".
   * Null = a transfer-included offer with no pickup (packages-api refuses it with EXCURSION_PICKUP_REQUIRED, shown by the cart / checkout).
   */
  readonly pickup = computed<{ text: string; translate: boolean } | null>(() => {
    const d = this.data();
    if (!d) return null;
    if (d.pickUpPointID) {
      const name = this.pickupHotelName()?.trim();
      return name ? { text: name, translate: false } : { text: 'pickup from your hotel', translate: true };
    }
    const address = d.pickUpAddress?.trim();
    if (address) return { text: address, translate: false };
    return d.offer?.transportationIncluded ? null : { text: 'no pickup - direct entry', translate: true };
  });
}
